import React, { useEffect, useState } from "react";
import { Container, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import addicon from "../../assets/images/addicon.svg";
import deleteAction from "../../assets/images/deleteaction.svg";
import editAction from "../../assets/images/editaction.svg";
import DeleteModal from "../../Modals/DeleteModal";
import PasswordVaultModal from "../../Modals/PasswordVaultModal";
import { API_URL } from "../../services/APIRoute";
import {
    googleString,
    inputJS,
} from "../../services/ReduxTookit/UserInfoSlice";
import {
    PasswordVaultgetlist,
    PasswordVaultSave,
} from "../../services/ReduxTookit/Slice/PasswordVaultRedux";
import Loader, { LoaderType } from "../common-component/Loader";
import Nodata from "./Nodata";
import { ProjectTermGetList } from "../../services/ReduxTookit/Slice/ProjectTermRedux";
import WebhookCommonModal from "../Workflow/FlowNewModels/WebhookCommonModal";
import { commonservices } from "../../services/CommonServices";
import PasswordValutWebhook from "./PasswordValutWebhook";
import { detailsbyhooktype } from "../../services/ReduxTookit/Slice/WebhookDetailsRedux";
import VaultTypeIcon from "./VaultTypeIcon";
import "../../Modals/PasswordVaultWizard.css";

const PasswordVault = ({ setPasswordWalletState, passwordWalletState }) => {
    let dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    //const GoogleData = useSelector((state) => state?.userinfo?.googleString);
    //let InputValueData = null;
    //if (localStorage.getItem("inputValue")) {
    //    InputValueData = JSON.parse(localStorage.getItem("inputValue"));
    //}
    const [PasswordVaultList, setPasswordVaultList] = useState([]);
    const [subLoader, setSubLoader] = useState("");
    const [SelectedVaultData, setSelectedVaultData] = useState();
    const [DeletePasswordVaultModalShow, setDeletePasswordVaultModalShow] =
        useState(false);
    const [VaultTypeList, setVaultTypeList] = useState([]);
    const [PasswordVaultModalShow, setPasswordVaultModalShow] = useState(false);
    const [WebhookModalShow, setWebhookModalShow] = useState(false);
    const [PasswordVaultModalType, setPasswordVaultModalType] = useState("");
    const [PasswordLoader, setPasswordLoader] = useState(false);
    const [DeletePayload, setDeletePayload] = useState({
        id: "",
    });
    const [enableWebhook, setEnableWebhook] = useState(false);

    const closeEnableWebhook = () => {
        setEnableWebhook(false);
    };
    const [isSaved, setIsSaved] = useState(false);
    //useEffect(() => {
    //    if (!isSaved && GoogleData && InputValueData) {
    //        let newVal = [];
    //        if (InputValueData?.detailsjson?.length > 0) {
    //            InputValueData.detailsjson.forEach((element) => {
    //                newVal.push({
    //                    [element?.keyname]: element?.value,
    //                });
    //            });
    //        }
    //        let filterVal = Object.assign({}, ...newVal);
    //        filterVal["auth_object"] = GoogleData;

    //        let body = {
    //            passwordvaultid: InputValueData?.passwordvaultid,
    //            type: InputValueData?.type,
    //            detailsjson: JSON.stringify(filterVal),
    //            displayname: InputValueData?.displayname,
    //            username: "",
    //            password: "",
    //        };

    //        dispatch(PasswordVaultSave(body))?.then((response) => {
    //            if (response?.payload?.isValidate) {
    //                localStorage.removeItem("inputValue");
    //                // navigate("/management-listing");
    //                // const params = new URLSearchParams(location.search);
    //                // ["code", "scope", "authuser", "hd", "prompt"].forEach((param) => {
    //                //   params.delete(param);
    //                // });
    //                setTimeout(() => {
    //                    dispatch(googleString(null));
    //                }, 1000);
    //                navigate(
    //                    {
    //                        pathname: location.pathname,
    //                        // search: params.toString(),
    //                    },
    //                    { replace: true, state: "passwordvault" }
    //                );
    //            }
    //        });

    //        setIsSaved(true);
    //    }
    //}, [GoogleData, InputValueData, isSaved, dispatch, navigate, location]);
    useEffect(() => {
        setEnableWebhook(passwordWalletState);
    }, [passwordWalletState]);
    async function getPasswordVaultList() {
        setPasswordLoader(true);
        dispatch(PasswordVaultgetlist({}))
            .then((response) => {
                if (response?.payload?.isValidate) {
                    setPasswordVaultList(response?.payload?.data?.data);
                }
                if (!response?.payload?.isValidate) {
                    setPasswordVaultList([]);
                }
            })
            .finally(() => {
                setPasswordLoader(false);
            });
    }
    async function getProjectTermList() {
        dispatch(ProjectTermGetList({}))?.then((response) => {
            if (response?.payload?.isValidate) {
                if (response?.payload?.data?.data?.length > 0) {
                    let temp = response?.payload?.data?.data.filter(
                        (f) => f.category === "Password Vault Type"
                    );
                    setVaultTypeList(temp || []);
                }
            }
            if (!response?.payload?.isValidate) {
            }
        });
    }

    const GetWebhookData = () => {
        setSubLoader(true);
        dispatch(
            detailsbyhooktype({
                hooktype: "get-vault-details",
                associationid: "0",
                associationtype: "Password Vault",
            })
        )?.then((res) => {
            //
            setSubLoader(false);
            if (res?.payload?.data?.data) {
                setEnableWebhook(true);
            }
        });
    };
    useEffect(() => {
        getProjectTermList();
        getPasswordVaultList();
        GetWebhookData();
    }, []);

    return (
        <div className="projects-page-main compateline-common">
            <Container>
                <div className="top-bot-section contactpage-inner-set">
                    {/* <h6>
            Contacts{ContactList?.length > 0 && ` (${ContactList?.length})`}
          </h6> */}
                    <div className="top-bot-right-section">
                        {/* <Link>
              <div
                className="filtering-main position-relative"
                id="add-project"
                onClick={(e) => {
                  e.preventDefault();
                  setWebhookModalShow(true);
                  // setPasswordVaultModalType("Create");
                }}
               
              >
               
                <span>Webhook</span>
              </div>
            </Link> */}
                        <Link>
                            <div
                                className="filtering-main position-relative"
                                id="add-project"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setPasswordVaultModalShow(true);
                                    setPasswordVaultModalType("Create");
                                }}
                            // ref={target}
                            >
                                <img src={addicon} alt="filtericon" />
                                <span>Add</span>
                            </div>
                        </Link>
                    </div>
                </div>
            </Container>
            <div className="main-page-content compateline-common setting-webhook-main">
                <>
                    <div className="table-wrapper-main">
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th className="width200">Type</th>
                                    <th className="width200">Display Name</th>
                                    <th className="width200">User Name</th>
                                    <th className="width160">Last Update</th>
                                    <th className="text-center width140">Status</th>
                                    <th className="text-end sticky-actions">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {PasswordLoader ? (
                                    <Loader type={LoaderType.TableRow} count={5} nooftd={6} />
                                ) : (
                                    <>
                                        {PasswordVaultList?.length > 0 ? (
                                            PasswordVaultList?.map((item, index) => {
                                                const matchingTerm = VaultTypeList?.find(
                                                    (f) => f.term?.toLowerCase() === item?.type?.toLowerCase()
                                                );
                                                const updateDate = item?.updatedon || item?.createdon;
                                                const formattedDate = updateDate
                                                    ? commonservices.convertDateToLocal(updateDate)
                                                    : "-";
                                                const isActive = item?.isactive !== false;

                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <VaultTypeIcon
                                                                    type={item?.type}
                                                                    details={matchingTerm?.details}
                                                                    size={24}
                                                                />
                                                                <span>{item?.type}</span>
                                                            </div>
                                                        </td>
                                                        <td className="width200">
                                                            {commonservices.truncateText(item?.displayname, 20)}
                                                        </td>
                                                        <td>
                                                            {" "}
                                                            {commonservices.truncateText(item?.username, 30)}
                                                        </td>
                                                        <td className="width160">
                                                            {formattedDate}
                                                        </td>
                                                        <td className="text-center width140">
                                                            <span className={`vault-status-pill ${isActive ? "active" : "inactive"}`}>
                                                                {isActive ? "Active" : "Inactive"}
                                                            </span>
                                                        </td>
                                                        <td className="sticky-actions">
                                                            <div className="all-actions">
                                                                <img
                                                                    src={editAction}
                                                                    alt="editAction"
                                                                    title="Edit"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setSelectedVaultData(item);
                                                                        setPasswordVaultModalShow(true);
                                                                        setPasswordVaultModalType("Update");
                                                                    }}
                                                                />
                                                                <img
                                                                    src={deleteAction}
                                                                    alt="deleteAction"
                                                                    title="Delete"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setDeletePasswordVaultModalShow(true);
                                                                        setDeletePayload({
                                                                            ...DeletePayload,
                                                                            id: item?.passwordvaultid,
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr className="text-center">
                                                <td colSpan={6}>
                                                    <Nodata />
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                )}
                            </tbody>
                        </Table>
                    </div>
                    <>
                        <div className="profile-common-title mt-2">
                            <h3>Create Webhook</h3>
                        </div>
                        {enableWebhook ? (
                            <div className="profile-common">
                                <PasswordValutWebhook
                                    hooktype="get-vault-details"
                                    associationid="0"
                                    associationtype="Password Vault"
                                    closeComp={closeEnableWebhook}
                                />
                            </div>
                        ) : (
                            <>
                                {subLoader ? (
                                    <Loader type={LoaderType.Line} count={3} />
                                ) : (
                                    <div className="profile-common">
                                        <div className="twofactor-profile">
                                            <h3>Enhance Your Integration with Webhooks</h3>
                                            <p>
                                                Seamlessly connect your applications by enabling
                                                Webhooks. This simple, real-time setup allows you to
                                                receive instant updates and automate workflows by
                                                sending data to your specified endpoint whenever an
                                                event occurs.
                                            </p>

                                            <div className="d-flex justify-content-center">
                                                <button
                                                    className="green-btn "
                                                    onClick={() => {
                                                        setEnableWebhook(true);
                                                        setPasswordWalletState(true);
                                                    }}
                                                >
                                                    Enable Webhook
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                </>
            </div>
            {PasswordVaultModalShow && (
                <PasswordVaultModal
                    selecteddata={SelectedVaultData}
                    type={PasswordVaultModalType}
                    show={PasswordVaultModalShow}
                    bindlist={getPasswordVaultList}
                    vaulttypelist={VaultTypeList}
                    onHide={(e) => setPasswordVaultModalShow(false)}
                />
            )}
            {DeletePasswordVaultModalShow && (
                <DeleteModal
                    payload={DeletePayload}
                    url={API_URL.PASSOWORDVAULT.DELETE}
                    method="DELETE"
                    show={DeletePasswordVaultModalShow}
                    bindlist={getPasswordVaultList}
                    onHide={(e) => setDeletePasswordVaultModalShow(false)}
                />
            )}
            {WebhookModalShow && (
                <WebhookCommonModal
                    hooktype="get-vault-details"
                    associationid="0"
                    associationtype="Password Vault"
                    show={WebhookModalShow}
                    onHide={(e) => setWebhookModalShow(false)}
                />
            )}
        </div>
    );
};

export default PasswordVault;
